module.exports = __webpack_public_path__ + "static/local-video-d85290ac0ca7445cf3354775542c468d.mp4";